import { useSanctumAppConfig } from "../../composables/useSanctumAppConfig.js";
export default async function handleRequestTokenHeader(app, ctx, logger) {
  const appConfig = useSanctumAppConfig();
  const token = await appConfig.tokenStorage.get(app);
  if (!token) {
    logger.debug("Authentication token is not set in the storage");
    return;
  }
  ctx.options.headers = {
    ...ctx.options.headers,
    Authorization: `Bearer ${token}`
  };
}
